export const inputLabelStyles = {
  fontSize: "0.875rem",
  fontWeight: 600,
  color: "text.secondary",
  "&.Mui-focused": {
    color: "primary.main",
    fontWeight: 600,
  },
};

export const selectStyles = {
  borderRadius: 3,
  backgroundColor: "background.paper",
  height: 48,
  transition: "all 0.2s ease-in-out",
  "& fieldset": {
    borderColor: "grey.300",
    borderWidth: 1.5,
  },
  "&:hover fieldset": {
    borderColor: "primary.main",
    borderWidth: 2,
  },
  "&.Mui-focused fieldset": {
    borderColor: "primary.main",
    borderWidth: 2,
    boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.1)",
  },
  "& .MuiSelect-select": {
    padding: "12px 14px",
    fontSize: "0.875rem",
    display: "flex",
    alignItems: "center",
  },
};

export const menuProps = {
  PaperProps: {
    sx: {
      borderRadius: 2,
      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
      mt: 1,
      "& .MuiMenuItem-root": {
        padding: "12px 16px",
        fontSize: "0.875rem",
        borderBottom: "1px solid",
        borderColor: "grey.100",
        transition: "all 0.15s ease-in-out",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "rgba(25, 118, 210, 0.08)",
        },
        "&.Mui-selected": {
          backgroundColor: "rgba(25, 118, 210, 0.12)",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.16)",
          },
        },
      },
    },
  },
};

export const chipStyles = {
  height: 26,
  backgroundColor: "primary.main",
  color: "primary.contrastText",
  fontWeight: 600,
  fontSize: "0.75rem",
  borderRadius: 2,
  "& .MuiChip-label": {
    px: 1.5,
  },
};

export const datePickerTextFieldStyles = {
  "& .MuiOutlinedInput-root": {
    height: 48,
    borderRadius: 3,
    backgroundColor: "background.paper",
    transition: "all 0.2s ease-in-out",
    "& fieldset": {
      borderColor: "grey.300",
      borderWidth: 1.5,
    },
    "&:hover fieldset": {
      borderColor: "primary.main",
      borderWidth: 2,
    },
    "&.Mui-focused fieldset": {
      borderColor: "primary.main",
      borderWidth: 2,
      boxShadow: "0 0 0 3px rgba(25, 118, 210, 0.1)",
    },
  },
  "& .MuiInputBase-input": {
    padding: "12px 14px",
    fontSize: "0.875rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "text.secondary",
    "&.Mui-focused": {
      color: "primary.main",
      fontWeight: 600,
    },
  },
};
